import { useState, useEffect } from "react";
import { getUserProfile } from "../services/usersService";
import { User } from "../interfaces/User";

/**
 * Hook to get user's country from profile for date formatting
 * Returns country or null (which will use browser locale as fallback)
 * Handles caching and error states
 */
export function useUserCountry(): string | null {
  const [country, setCountry] = useState<string | null>(null);
  const [hasFetched, setHasFetched] = useState(false);

  useEffect(() => {
    // Only fetch once
    if (hasFetched) return;

    const fetchCountry = async () => {
      try {
        const response = await getUserProfile();
        const userProfile = response.data as User;
        setCountry(userProfile?.country || null);
      } catch (error) {
        console.warn("Failed to fetch user profile for country:", error);
        // Continue with null - will use browser locale as fallback
        setCountry(null);
      } finally {
        setHasFetched(true);
      }
    };

    fetchCountry();
  }, [hasFetched]);

  return country;
}

